module Dashboard {
    "use strict";

    export class DashboardConfigService {
        public widgetTypes: Function[];
        public widgets: IWidgetConfig[];
        public siteRoot: string;
        private localStorageKey: string;
    
        static $inject = [];
        constructor() {
            this.siteRoot = angular.element("base").attr("href");
            this.localStorageKey = this.siteRoot + "dashboardConfig"
            this.registerWidgetTypes();
            this.populateWidgetsArray();
        }

        private registerWidgetTypes() {
            // Widget types are used to populate the add widgets dropdown menu.
            // When creating new Widgets, add the config type to this list
            this.widgetTypes = [
                SuccessfulExecutionsWidgetConfig,
                FailedExecutionsWidgetConfig,
                NotificationsWidgetConfig,
                ExecutionGraphWidgetConfig
            ];
        }

        private populateWidgetsArray() {
            const savedConfig = localStorage.getItem(this.localStorageKey);
            if (savedConfig) {
                this.widgets = <IWidgetConfig[]>JSON.parse(savedConfig);
            } else {
                this.widgets = [];
                _.each(this.widgetTypes, (widgetCtor) => {
                    let instance = this.getWidgetInstance(widgetCtor);
                    if (instance.enabledByDefault) {
                        this.widgets.push(instance);
                    }
                });
                this.save();
            }
        }

        public updateWidgetConfig(config: IWidgetConfig) {
            let widgetIndex = _.findIndex(this.widgets, widget => widget.id === config.id);

            if (widgetIndex !== -1) {
                this.widgets[widgetIndex] = config;
                this.save();
            }
        }

        public getWidgetInstance(widgetCtor) {
            return new widgetCtor(this.generateWidgetId());
        }

        public save() {
            const configString = JSON.stringify(this.widgets);
            localStorage.setItem(this.localStorageKey, configString);
        }

        public addWidget(widgetCtor) {
            let instance = this.getWidgetInstance(widgetCtor);
            this.widgets.push(instance);
            this.save();
        }

        public removeWidget(id: string) {
            let widgetIndex = _.findIndex(this.widgets, widget => widget.id === id);

            if (widgetIndex !== -1) {
                this.widgets.splice(widgetIndex, 1);
                this.save();
            }
        }

        private generateWidgetId() {
            let id = (Math.random() + 1).toString(36).substring(7);
            let match = _.find(this.widgets, (w) => w.id === id);
            if (match) {
                id = this.generateWidgetId();
            }
            return id;
        }
    }

    module.service("DashboardConfigService", DashboardConfigService);
}